import styled, { css } from 'styled-components';
import { DEEP_BORDER_BOX } from 'common';
import {
  SPACING_24,
  SPACING_16,
  SPACING_8,
  SPACING_4,
  SPACING_2,
  SPACING_0
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

const BORDER_STYLE =
  ({ variant, $theme }) => variant === 'outlined'
    ? css`box-shadow: inset 0 0 0 0.0625rem ${$theme.border}`
    : css`box-shadow: inset 0 -0.0625rem 0 0 ${$theme.border}`;

const GET_BORDER_COLOR = props =>
  props.disabled ? props.$theme.disabled.border
    : props.error ? props.$theme.error.border
      : props.hovered ? props.$theme.hover.border
        : props.focused ? props.$theme.focused.border
          : props.$theme.border;

const GET_OUTLINED_FOCUSED_STYLE = props => `inset 0 0 0 ${SPACING_2} ${GET_BORDER_COLOR(props)}`;
const GET_UNDERLINED_FOCUSED_STYLE = props => `inset 0 -${SPACING_2} 0 0 ${GET_BORDER_COLOR(props)}`;
const GET_FOCUSED_BORDER_STYLE = props => props.variant === 'outlined'
  ? GET_OUTLINED_FOCUSED_STYLE(props)
  : GET_UNDERLINED_FOCUSED_STYLE(props);

export default {
  SearchwChipsCore: styled.div`
    overflow: auto;
    ${DEEP_BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    ${props => css`margin: ${(props.RTL || props.$rtl || props.rtl) ? `0 ${SPACING_24} 0 ${SPACING_16}` : `0 ${SPACING_16} 0 ${SPACING_24}`};`}
    ${props => css`min-height: ${props.size === 'medium' ? '3rem' : '2.25rem'};`}
    width: calc(100% - (${SPACING_16} + ${SPACING_24}));
    min-width: calc(100% - (${SPACING_16} + ${SPACING_24}));
    max-width: calc(100% - (${SPACING_16} + ${SPACING_24}));
    display: flex;
    align-items: flex-start;
    ${props => (!props.$disableAnimation) && css`transition: box-shadow 0.1s ease-in-out`};
    background: ${({ $theme }) => $theme.background};
    user-select: none;
    ${props => (props.variant === 'underlined' || props.variant === 'outlined') && css`box-shadow: ${GET_FOCUSED_BORDER_STYLE(props)}`};
    ${({ focused, error, hovered }) => !focused && !hovered && !error && css`
      ${BORDER_STYLE}
    `};
  `,
  ChipsWrapper: styled.div`
    ${props => css`flex-direction: ${(props.RTL || props.$rtl || props.rtl) ? 'row-reverse' : 'row'};`}
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ${props => css`padding: ${props.size === 'medium' ? `${SPACING_4} 0` : `${SPACING_2} 0`};`}
    padding: ${SPACING_4} 0
  `,
  ExtraElementsWrapper: styled.div`
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    padding-top: ${SPACING_8};
    padding-bottom: ${SPACING_8};
    ${props => css`padding-left: ${(props.RTL || props.$rtl || props.rtl) ? SPACING_0 : SPACING_8};`}
    ${props => css`padding-right: ${(props.RTL || props.$rtl || props.rtl) ? SPACING_8 : SPACING_0};`}
  `,
  SearchwChipsOperator: styled.div`
    user-select: none;
    color: ${({ $theme, selected }) => selected ? $theme.selected.content : $theme.default.content};
    background: ${({ $theme, selected }) => selected ? $theme.selected.background : $theme.default.background};
    &:focus {
      outline: none; 
      color: ${({ $theme, selected }) => selected ? $theme.selected.focused.content : $theme.default.focused.content};
      background: ${({ $theme, selected }) => selected ? $theme.selected.focused.background : $theme.default.focused.background};
    }
    &:hover {
      color: ${({ $theme, selected }) => selected ? $theme.selected.hovered.content : $theme.default.hovered.content};
      background: ${({ $theme, selected }) => selected ? $theme.selected.hovered.background : $theme.default.hovered.background};
    }
    &:hover&:focus {
     outline: none; 
     color: ${({ $theme, selected }) => selected ? $theme.selected.hoveredFocused.content : $theme.default.hoveredFocused.content};
     background: ${({ $theme, selected }) => selected ? $theme.selected.hoveredFocused.background : $theme.default.hoveredFocused.background};
    }
  `
};